import { signOut } from 'aws-amplify/auth';

export const attemptSignOut = async () => signOut();

const authSignOut = async () => attemptSignOut();

export default authSignOut;
